import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import "../css/home.css";
// import WhatsAppFloat from "../components/whatsapp";
import Footer from "../components/footer";
import wedding from "../images/weddingcake.jpg";
import gridImage1 from "../images/Gemini_Generated_Image_jcastdjcastdjcas.jpg";
import gridImage2 from "../images/giftboxes.jpg";
import gridImage3 from "../images/roundcakes.jpg";
import gridImage4 from "../images/squarecakes.jpg";
import gridImage5 from "../images/1hourclickandcollect.jpg";
import hero1 from "../images/hero1.jpeg";
import hero2 from "../images/hero2.jpg";
import hero3 from "../images/hero3.jpg";
import cake1 from "../images/cake1.jpeg";
import cake2 from "../images/cake7.jpeg";

import fruitsofeden from "../images/fruitsofeden.jpg";
import theclassicsquare from "../images/theclassicsquare.jpg";
import vintageheartbow from "../images/vintageheartbow.jpg";
import dripdelux from "../images/dripdelux.jpg";
import spidermancake from "../images/spidermancakeround.jpg";

const slides = [hero1, hero2, hero3];

const sideImages = [
  {
    img: gridImage3,
    text: "Round Cakes",
    alt: "Custom round cakes for birthdays and events in Walsall",
    targetCategory: "Round",
  },
  {
    img: gridImage4,
    text: "Square Cakes",
    alt: "Modern square tiered cakes",
    targetCategory: "Square",
  },
  {
    img: gridImage1,
    text: "Heart Cakes",
    alt: "Delicious gluten-free celebration cakes Walsall",
    targetCategory: "Heart",
  },
  {
    img: gridImage2,
    text: "Gift Boxes",
    alt: "Vegan cakes baked fresh in Walsall",
    targetCategory: "Gift Boxes",
  },
  {
    img: gridImage5,
    text: "1h Click & Collect",
    alt: "1-Hour Click and Collect bakery service in Walsall",
    targetCategory: "All",
  },
];

const bentoImages = {
  signature: fruitsofeden,
  square: theclassicsquare,
  heart: vintageheartbow,
  drip: dripdelux,
  kids: spidermancake,
};

const Home = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  // Auto-advance slideshow
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  // Shared inline styles for the bento cards to keep images flush
  const bentoCardStyle = {
    display: "flex",
    flexDirection: "column",
    padding: 0,
    overflow: "hidden",
    backgroundColor: "#fff",
    textDecoration: "none",
    color: "inherit",
  };

  const bentoImgStyle = {
    width: "100%",
    height: "200px",
    objectFit: "cover",
  };

  const bentoContentStyle = {
    padding: "1.5rem",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    flex: 1,
  };

  return (
    <div className="home-wrapper">
      <Helmet>
        <title>Lovely Cakes | Home</title>
        <meta
          name="description"
          content="Order beautiful, handcrafted custom cakes from Lovely Cakes in Walsall. We specialize in birthday cakes, 100% eggless, vegetarian, halal, vegan, and 1-hour click & collect options."
        />
        <meta
          name="keywords"
          content="bakery Walsall, custom cakes Walsall, eggless cakes Walsall, halal cakes Walsall, birthday cakes Walsall, vegetarian cakes Walsall, vegan bakery Walsall, click and collect cake Walsall"
        />
      </Helmet>

      <section className="hero-split-section">
        <div className="hero-slideshow-container">
          {slides.map((slide, index) => (
            <div
              key={index}
              className={`slide ${index === currentSlide ? "active" : ""}`}
              style={{ backgroundImage: `url(${slide})` }}
              aria-label="Beautiful custom cakes showcase"
            >
              <div className="slide-overlay">
                <div className="hero-actions">
                  <Link
                    to="/cakes"
                    className="luxe-btn primary-luxe"
                    aria-label="Explore our full cake menu"
                  >
                    Explore Our Cakes
                  </Link>
                </div>
              </div>
            </div>
          ))}
          <div className="slide-indicators">
            {slides.map((_, index) => (
              <span
                key={index}
                className={`dot ${index === currentSlide ? "active" : ""}`}
                onClick={() => setCurrentSlide(index)}
                aria-label={`Go to slide ${index + 1}`}
              ></span>
            ))}
          </div>
        </div>

        <div className="hero-side-grid">
          {sideImages.map((item, index) => (
            <Link
              key={index}
              to="/cakes"
              state={{ category: item.targetCategory }}
              className="side-grid-item image-item"
              style={{
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
                backgroundColor: "#fff",
                textDecoration: "none",
                color: "inherit",
              }}
            >
              <img
                src={item.img}
                alt={item.alt}
                style={{ width: "100%", height: "80%", objectFit: "cover" }}
              />
              <div
                className="logo-text"
                style={{
                  height: "20%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "5px",
                  textAlign: "center",
                  fontWeight: "600",
                  color: "#333",
                  fontSize: "0.9rem",
                }}
              >
                {item.text}
              </div>
            </Link>
          ))}
        </div>
      </section>

      {/* --- REFINED, MODERN ABOUT US SECTION --- */}
      <section className="about-us-section">
        <div className="modern-about-container">
          <div className="about-text-side">
            <span className="section-overline">Our Story</span>
            <h2 className="section-title">Welcome to Lovely Cakes</h2>
            <p>
              Baking isn't just our profession—it's an art form born from a
              lifelong passion for bringing joy to life's most precious moments.
              We pour our hearts into every creation, meticulously handcrafting
              each tier and piping every delicate detail using only the finest,
              thoughtfully sourced ingredients.
            </p>
            <p>
              Whether you're celebrating a milestone birthday, an intimate
              anniversary, or a quiet personal victory, our cakes are designed
              not just to be eaten, but to be experienced. We are here to
              transform your most cherished milestones into unforgettable,
              edible masterpieces right here in Walsall.
            </p>

            <div style={{ marginTop: "1rem" }}>
              <Link to="/aboutus" className="luxe-btn secondary-luxe">
                Discover Our Story
              </Link>
            </div>
          </div>

          {/* Editorial overlapping images */}
          <div className="editorial-images">
            <img
              src={cake1}
              alt="Elegant tiered celebration cake in Walsall"
              className="img-primary"
              loading="lazy"
            />
            <img
              src={cake2}
              alt="Beautiful custom birthday cake with floral design"
              className="img-secondary"
              loading="lazy"
            />
          </div>
        </div>
      </section>

      <section className="bento-section">
        <div className="section-heading">
          <h2>Our Custom Cake Collections</h2>
          <Link to="/cakes" className="view-all">
            View Full Menu &rarr;
          </Link>
        </div>

        <div className="bento-grid">
          <Link
            to="/cakes"
            state={{ category: "Round" }}
            className="bento-item bento-large material-shadow"
            style={{
              backgroundImage: `url(${bentoImages.signature})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              textDecoration: "none",
              color: "inherit",
            }}
            aria-label="Signature round cake topped with fresh fruit"
          >
            <div className="bento-content">
              <h3>Signature Round Cakes</h3>
              <p>
                Vibrant, classic round cakes topped with fresh seasonal fruits
                and baked fresh daily for your celebrations.
              </p>
            </div>
          </Link>

          <Link
            to="/cakes"
            state={{ category: "Square" }}
            className="bento-item bento-small material-shadow"
            style={bentoCardStyle}
          >
            <img
              src={bentoImages.square}
              alt="Modern elegant square birthday cakes"
              style={bentoImgStyle}
              loading="lazy"
            />
            <div style={bentoContentStyle}>
              <h3>Modern Square Cakes</h3>
              <p>
                Clean lines, sharp edges, and simple elegance for a sleek
                celebration.
              </p>
            </div>
          </Link>

          <Link
            to="/cakes"
            state={{ category: "Heart" }}
            className="bento-item bento-small material-shadow"
            style={bentoCardStyle}
          >
            <img
              src={bentoImages.heart}
              alt="Vintage piped heart cakes for anniversaries"
              style={bentoImgStyle}
              loading="lazy"
            />
            <div style={bentoContentStyle}>
              <h3>Vintage Heart Cakes</h3>
              <p>
                Piped with love and care, perfect for anniversaries and sweet
                gestures.
              </p>
            </div>
          </Link>

          <Link
            to="/cakes"
            state={{ category: "All" }}
            className="bento-item bento-small material-shadow"
            style={bentoCardStyle}
          >
            <img
              src={bentoImages.drip}
              alt="Decadent custom drip cakes loaded with treats"
              style={bentoImgStyle}
              loading="lazy"
            />
            <div style={bentoContentStyle}>
              <h3>Decadent Drip Cakes</h3>
              <p>
                Rich, generous layers topped with beautiful drips and your
                favorite treats.
              </p>
            </div>
          </Link>

          <Link
            to="/cakes"
            state={{ category: "Kids" }}
            className="bento-item bento-small material-shadow"
            style={bentoCardStyle}
          >
            <img
              src={bentoImages.kids}
              alt="Spiderman and themed kids birthday cakes"
              style={bentoImgStyle}
              loading="lazy"
            />
            <div style={bentoContentStyle}>
              <h3>Kids & Themed</h3>
              <p>
                Joyful, colorful character cakes made to bring a smile to their
                faces.
              </p>
            </div>
          </Link>
        </div>
      </section>

      {/* Dietary Highlights Banner */}
      <section
        className="dietary-banner-section"
        style={{
          backgroundColor: "#faf8f5",
          padding: "4rem 2rem",
          textAlign: "center",
        }}
      >
        <h2 style={{ marginBottom: "1rem", fontSize: "1.8rem", color: "#333" }}>
          Baked for Everyone
        </h2>
        <p
          style={{
            maxWidth: "600px",
            margin: "0 auto 2.5rem",
            color: "#666",
            lineHeight: "1.6",
          }}
        >
          We believe every celebration deserves a beautiful, delicious cake.
          That’s why our kitchen proudly specializes in an inclusive menu,
          handcrafting stunning centerpieces tailored to your dietary needs.
        </p>

        <div
          className="dietary-badges"
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "3rem",
            flexWrap: "wrap",
            fontWeight: "600",
            color: "#222",
            fontSize: "1rem",
            textTransform: "uppercase",
            letterSpacing: "1.5px",
          }}
        >
          <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <span style={{ fontSize: "1.3rem" }}>🥚</span> 100% Eggless
          </span>
          <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <span style={{ fontSize: "1.3rem" }}>✨</span> Halal
          </span>
          <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <span style={{ fontSize: "1.3rem" }}>🌱</span> Vegan
          </span>
        </div>
      </section>

      <section className="editorial-philosophy">
        <div
          className="philosophy-statement"
          style={{ fontSize: "2rem", fontWeight: "bold" }}
        >
          "Baking with love, creating{" "}
          <span className="highlight-text">memories</span> with every bite."
        </div>
        <div className="philosophy-author">
          <span className="author-name">— Lovely Cakes Walsall</span>
        </div>
      </section>

      {/* <WhatsAppFloat /> */}
      <Footer />
    </div>
  );
};

export default Home;
